import { ResultPrice } from 'models/auto/price';
import { VehicleInclusion, VehicleRatesValidate } from 'models/auto/vehicle';
import { PriceCost } from 'models/auto/vehicleBooking';
import { VehicleValidateResponse } from 'models/auto/vehicleValidate';
import { VehicleBookRateInclusions, VehicleBookReservation } from 'models/autoSolicitation';

import { VehicleBookPassenger } from './../models/autoSolicitation';

export const mapVehicleReservation = (
  vehicle: VehicleValidateResponse,
  breakRulesMessage?: string[],
  passengers?: VehicleBookPassenger[],
): VehicleBookReservation => {
  const reservation: VehicleBookReservation = {
    pickupDateTime: `${vehicle.vehicleOption.pickUp?.time}`,
    dropoffDateTime: `${vehicle.vehicleOption.dropOff?.time}`,
    company: {
      code: `${vehicle.vehicleOption.company?.code}`,
      name: `${vehicle.vehicleOption.company?.name}`,
    },
    pickupLocation: {
      destinationCode: `${vehicle.vehicleOption.pickUp?.destinationCode}`,
      address: `${vehicle.vehicleOption.pickUp?.address}`,
      latitude: vehicle.vehicleOption.pickUp?.latitude ? vehicle.vehicleOption.pickUp?.latitude : 0,
      longitude: vehicle.vehicleOption.pickUp?.longitude ? vehicle.vehicleOption.pickUp?.longitude : 0,
    },
    dropoffLocation: {
      destinationCode: `${vehicle.vehicleOption.dropOff?.destinationCode}`,
      address: `${vehicle.vehicleOption.dropOff?.address}`,
      latitude: vehicle.vehicleOption.dropOff?.latitude ? vehicle.vehicleOption.dropOff?.latitude : 0,
      longitude: vehicle.vehicleOption.dropOff?.longitude ? vehicle.vehicleOption.dropOff?.longitude : 0,
    },
    rateDescription:
      vehicle.vehicleOption.rates && vehicle.vehicleOption.rates[0]
        ? `${vehicle.vehicleOption.rates[0].rateDescription}`
        : '',
    rateInclusions:
      vehicle.vehicleOption.rates && vehicle.vehicleOption.rates[0]
        ? mapRatesInclusions(vehicle.vehicleOption.rates[0])
        : [],
    ownerUsername: '',
    ownerReferenceCode: '',
    referenceCode: '',
    status: '',
    reservationType: '',
    id: 0,
    travelItineraryId: 0,
    supplierReferenceCode: '',
    createdDate: `${vehicle.vehicleOption.pickUp?.time}`,
    confirmedDate: `${vehicle.vehicleOption.pickUp?.time}`,
    roe: {
      from: '',
      to: '',
      amount: 0,
    },
    productReference: '',
    quantity: 0,
    textFare: '',
    confirmationNumber: '',
    commentContracts: '',
  };

  if (vehicle.vehicleOption.rates && vehicle.vehicleOption.rates[0]) {
    const rate = vehicle.vehicleOption.rates[0];
    if (rate.price) reservation.cost = mapPriceCost(rate.price);
    reservation.price = {
      ...rate.price,
      breakRulesMessage: breakRulesMessage || [],
    };
    reservation.taxesPayableAtDestination = rate.taxesPayableAtDestination;
    reservation.totalPricePayNow = rate.totalPricePayNow ? rate.totalPricePayNow : 0;
    reservation.isPromo = rate.isPromo;
    reservation.isPayNow = rate.isPayNow;
  }

  if (vehicle.vehicleOption.commentContracts) reservation.commentContracts = vehicle.vehicleOption.commentContracts;
  if (vehicle.ttlDetails) reservation.ttl = vehicle.ttlDetails;
  if (vehicle.vehicleOption.vehicle) reservation.vehicle = vehicle.vehicleOption.vehicle;
  if (passengers) reservation.passengers = passengers;
  return reservation;
};

export const mapPriceCost = (price: ResultPrice): PriceCost =>
  price
    ? {
        currencyCode: `${price.currencyCode}`,
        amount: price.amount ? price.amount : 0,
        commission: price.commissionAmount ? price.commissionAmount : 0,
        overCommission: 0,
        surcharges: price.surcharges ? price.surcharges : 0,
        markup: 0,
      }
    : ({} as PriceCost);

export const mapRatesInclusions = (rate: VehicleRatesValidate): VehicleBookRateInclusions[] =>
  rate && rate.includes ? rate.includes.map((include) => mapRatesInclusion(include)) : [];

export const mapRatesInclusion = (include: VehicleInclusion): VehicleBookRateInclusions => ({
  name: include.name || '',
  description: include.description,
  inclusionType: include.inclusionType,
});
